var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dashboard-stat-card',{attrs:{"dark":"","icon":_vm.icon,"label":_vm.label,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }